import { ExpertState, ExpertStateNew, Gender } from "@/autoGeneratedGlobalTypes";
import {
  getExperts_getExperts_edges_node_desktopImage,
  getExperts_getExperts_edges_node_mobileImage,
  getExperts_getExperts_edges_node_rates,
  getExperts_getExperts_edges_node_reviewQuotes,
  getExperts_getExperts_edges_node_skills,
  getExperts_getExperts_edges_node_trialAllowance,
} from "@/components/catalog/graphql/__generated__/getExperts";

import { makePaymentWithSavedCardFromProfile_makePaymentWithSavedCard } from "./hooks/usePayWithSavedCard/graphql/__generated__/makePaymentWithSavedCardFromProfile";
import { purchaseProductWithSavedCard_purchaseProductWithSavedCard } from "./hooks/usePayWithSavedCard/graphql/__generated__/purchaseProductWithSavedCard";

export enum DeviceTypeEnum {
  Mobile = "mobile",
  Tablet = "tablet",
  Desktop = "desktop",
}

export enum BrowserNameEnum {
  Chrome = "chrome",
  Firefox = "firefox",
  Safari = "safari",
  Yandex = "yandex",
  Edge = "edge",
}

export enum OSNameEnum {
  IOS = "iOS",
  Android = "Android OS",
}

export enum CarouselSeoUrlPrefixEnum {
  Page = "",
  Article = "articles",
  Catalog = "catalog",
  Category = "category",
  Goroskop = "goroskop",
}
// type for payment extras order
export type PaymentExtrasOrderKey = "CLOUD" | "CLOUD_FOREIGN" | "ROBOKASSA_SBP" | "ROBOKASSA";

// config for buildPaymentDropdownOptions function
export type BuildPaymentDropdownOptionsConfig = {
  order: PaymentExtrasOrderKey[];
};

// payment type for now card & seved card
export type PaymentSuccessDataType = makePaymentWithSavedCardFromProfile_makePaymentWithSavedCard
| purchaseProductWithSavedCard_purchaseProductWithSavedCard

// Interface for object with images
export interface ImageUrls {
  xSmall: string;
  small: string;
  medium: string;
  large: string;
}

export interface Node {
  id: number | string; // todo: refactor when backend is changed
  name: string;
  description: string;
  mobileImage?: getExperts_getExperts_edges_node_mobileImage;
  desktopImage?: getExperts_getExperts_edges_node_desktopImage;
  rates: getExperts_getExperts_edges_node_rates;
  gender?: Gender;
  state: ExpertState | ExpertStateNew; // todo: refactor when backend is changed
  rating: number;
  skills: getExperts_getExperts_edges_node_skills[] | null;
  trialAllowance: getExperts_getExperts_edges_node_trialAllowance;
  category: string | null;
  minSessionDuration: number;
  nextAvailableAt: any | null;
  advantage?: string;
  reviewQuotes?: getExperts_getExperts_edges_node_reviewQuotes[];
}

export type ExtendedNode = Node & {
  stateInitial?: ExpertState;
};

export type ExpertEdgeType = {
  node: ExtendedNode;
  cursor?: string;
};

type PageInfoType = {
  endCursor: string;
  hasNextPage: boolean;
};

export type EdgesType = ExpertEdgeType[] | null;

export type PagedExpertsType = {
  edges: EdgesType;
  pageInfo: PageInfoType;
  totalCount: number;
}

export type ExpertsType = {
  edges: EdgesType;
};
